export const thousandSeparator = (num) => num?.toLocaleString();
